interface StatusCompletedIconProps {
  className?: string
}

export const StatusCompletedIcon: React.FC<StatusCompletedIconProps> = ({
  className = "",
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle
        cx="12.4999"
        cy="12.5001"
        r="9.6"
        stroke="#70E975"
        strokeWidth="1.2"
      />
      <path
        d="M7.48315 12.3975L10.8619 15.7762L17.5165 9.22388"
        stroke="#70E975"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
